import { defineComponent as _defineComponent } from 'vue'
import THGHeader from '@/components/thg/THGHeader.vue';
    import { onMounted } from 'vue';
    import { useTHGGlobalStore } from '@/storenew/thg/global';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THG',
  setup(__props) {

    const { dispatchPayoffs } = useTHGGlobalStore();

    onMounted(async () => {
        await dispatchPayoffs();
    });

return { __sfc: true,dispatchPayoffs, THGHeader }
}

})